function getConfig(name, defaultValue = null) {
  // If inside a docker container, use window.ENV
  if (window.ENV !== undefined) {
    return window.ENV[name] || defaultValue;
  }

  return import.meta.env[name] || defaultValue;
}

export function getBackendUrl() {
  return getConfig("VITE_BACKEND_URL");
}

export function getHoursCloseTicketsAuto() {
  return getConfig("VITE_HOURS_CLOSE_TICKETS_AUTO");
}

/**
 * Build the full media URL from a relative path or filename
 * @param {string} mediaUrl - The media URL (can be filename, relative path, or full URL)
 * @returns {string} The full media URL
 */
export function getMediaUrl(mediaUrl) {
  if (!mediaUrl) return "";

  // If already a full URL, return as is
  if (mediaUrl.startsWith("http://") || mediaUrl.startsWith("https://")) {
    return mediaUrl;
  }

  // If starts with data: (base64), return as is
  if (mediaUrl.startsWith("data:")) {
    return mediaUrl;
  }

  const backendUrl = getBackendUrl();
  // Remove trailing slash from backend URL
  const baseUrl = backendUrl?.replace(/\/$/, "") || "";

  // If it's just a filename, add /public/ prefix
  if (!mediaUrl.startsWith("/")) {
    return `${baseUrl}/public/${mediaUrl}`;
  }

  // If it already starts with /, just append to backend URL
  return `${baseUrl}${mediaUrl}`;
}
